import { Component, OnInit, output } from '@angular/core';

import { AnchorDirective, DynamicHtmlDirective } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';

import { UrlConstants } from '../../../../../config/urlConstants';
import { MessageType } from '../../../../../model/message.model';
import { BetslipQdApiService } from '../../../../../service/betslipqd-api.service';
import { DepositService } from '../../../../../service/deposit.service';
import { MessageComponent } from '../../messages/message-component';

@Component({
    selector: 'bqd-dep-curfew-message',
    templateUrl: 'deposit-curfew-message.component.html',
    imports: [AnchorDirective, MessageComponent, TranslateModule, DynamicHtmlDirective],
})
export class DepositCurfewMessageComponent implements OnInit {
    messageType = MessageType;
    activeDepositCurfewInfo = output<boolean>();

    activeDepositCurfew: boolean;
    isInPlayBreak: boolean;
    depositNewCurfewEnabled: boolean;
    depositCurfewEnabled: boolean;
    isTodayEndDate: boolean;
    allDayCurfew: boolean;
    depositCurfewEndDate: string;
    depositCurfewEndTime: string;
    depositCurfewRedirectUrl: string;
    depositCurfewDetails: any;

    constructor(
        private apiService: BetslipQdApiService,
        private depositService: DepositService,
    ) {}

    ngOnInit() {
        this.getDepositCurfewDetails();
    }

    getDepositCurfewDetails() {
        this.apiService.get(UrlConstants.DEPOSIT_CURFEW_DETAILS_URI).subscribe((response) => {
            if (response && response?.inDepositCurfew) {
                this.activeDepositCurfew = response?.inDepositCurfew;
                this.activeDepositCurfewInfo.emit(!!this.activeDepositCurfew);
                this.depositService.resizeCashier();
                this.isTodayEndDate = response?.todayEndDay;
                this.allDayCurfew = response?.allDayCurfew;
                this.depositCurfewEndDate = response?.endDate;
                this.depositCurfewEndTime = `${response?.endTime} ${response?.timeZone}`;
                this.depositCurfewRedirectUrl = response?.depositCurfewUrl?.url;
                this.depositNewCurfewEnabled = true;
            }
        });
    }
}
